export default __webpack_public_path__ + "static/media/cake.c1762fd7.svg";